import { InjectionToken } from '@angular/core';

export interface MiqSecuredResourcesConfig {
  s3Path: string;
  buildingPhName: string;
}
export const SECURED_RESOURCES_CONFIGS_TOKEN = new InjectionToken<MiqSecuredResourcesConfig>(
  'SECURED_RESOURCES_CONFIGS_TOKEN'
);
